var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 4.375L37.625 13.125M37.625 4.375L28.875 13.125M21.875 5.25H13.65C10.7097 5.25 9.23959 5.25 8.11655 5.82222C7.1287 6.32555 6.32555 7.1287 5.82222 8.11655C5.25 9.23959 5.25 10.7097 5.25 13.65V28.35C5.25 31.2903 5.25 32.7604 5.82222 33.8834C6.32555 34.8713 7.1287 35.6744 8.11655 36.1778C9.23959 36.75 10.7097 36.75 13.65 36.75H29.75C31.3775 36.75 32.1912 36.75 32.8588 36.5711C34.6705 36.0857 36.0857 34.6705 36.5711 32.8588C36.75 32.1912 36.75 31.3775 36.75 29.75M18.375 14.875C18.375 16.808 16.808 18.375 14.875 18.375C12.942 18.375 11.375 16.808 11.375 14.875C11.375 12.942 12.942 11.375 14.875 11.375C16.808 11.375 18.375 12.942 18.375 14.875ZM26.2326 20.8568L11.4295 34.3141C10.5969 35.071 10.1806 35.4495 10.1437 35.7773C10.1118 36.0615 10.2208 36.3434 10.4356 36.5322C10.6834 36.75 11.246 36.75 12.3712 36.75H28.798C31.3165 36.75 32.5758 36.75 33.5649 36.3269C34.8065 35.7957 35.7957 34.8065 36.3269 33.5649C36.75 32.5758 36.75 31.3165 36.75 28.798C36.75 27.9506 36.75 27.5269 36.6574 27.1323C36.5409 26.6364 36.3177 26.1719 36.0032 25.7712C35.7529 25.4524 35.4221 25.1877 34.7604 24.6583L29.8652 20.7422C29.2029 20.2123 28.8718 19.9474 28.5071 19.8539C28.1857 19.7715 27.8475 19.7822 27.5319 19.8847C27.1739 20.001 26.8601 20.2863 26.2326 20.8568Z",
    stroke: "#D0D5DD",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.1c24a959400dbfd62835a412d71cab9a.svg";
export { ForwardRef as ReactComponent };